var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconClock = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00361 14C10.8303 14 14 10.8303 14 6.99639C14 3.16968 10.8231 0 6.99639 0C3.16968 0 0 3.16968 0 6.99639C0 10.8303 3.1769 14 7.00361 14ZM3.47292 7.77617C3.19134 7.77617 2.97473 7.55957 2.97473 7.27076C2.97473 6.99639 3.19134 6.77978 3.47292 6.77978H6.4982V2.7148C6.4982 2.44043 6.7148 2.21661 6.99639 2.21661C7.27798 2.21661 7.49459 2.44043 7.49459 2.7148V7.27076C7.49459 7.55957 7.27798 7.77617 6.99639 7.77617H3.47292Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-clock.0503d4a350d97968813def5d674f6916.svg";